import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { useCheckoutStore, useAppStore } from "../store/Store";
import { Modal } from 'antd';

const CartModal = () => {
    const { showAddToCartModal, setShowAddToCartModal } = useCheckoutStore();
    const { openProductDrawer, productDrawer, closeProductDrawer, openDrawer  } = useAppStore();
    const navigate = useNavigate();
        const [isMobile, setIsMobile] = useState(false);


    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth < 600); // xs breakpoint is usually 576px
        };
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);



    if (!showAddToCartModal) return null;


    const handleContinueShopping = () => {
        setShowAddToCartModal(false);
        closeProductDrawer(); 
    };


    const handleViewCart = () => {
        setShowAddToCartModal(false);
        closeProductDrawer(); 
        
        if (isMobile) {
            // For mobile (xs screens), navigate to cart page
            navigate('/cart');
        } else {
            // For larger screens, open cart drawer
            openDrawer('cart');
        }
    };

    // Handle X button click - close modal AND reopen drawer
    const handleModalClose = () => {
        setShowAddToCartModal(false);
        
        // Check if we have a product to reopen
        if (productDrawer.product) {
            // Small delay to ensure modal animation completes
            setTimeout(() => {
                // Reopen drawer with the same product
                openProductDrawer(productDrawer.product);
            }, 100);
        }
    };

    return (
        <Modal
            open={showAddToCartModal}
            onCancel={handleModalClose} // X button triggers reopening
            footer={null}
            closable={true}
            width={420}
            centered
            style={{ top: 20 }}
        >
            <div style={{ padding: '8px 0 0' }}>
                {/* Header */}
                <div style={{ padding: '0 0 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontSize: '16px', fontWeight: 600, color: '#111', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '12px' }}>✓</div>
                        Added to Cart
                    </div>
                </div>

                {/* Success Message */}
                <div style={{ padding: '0 0 20px' }}>
                    <div style={{ fontSize: '14px', color: '#666', lineHeight: '1.5' }}>Product successfully added to your cart.</div>
                </div>

                {/* Buttons */}
                <div style={{ padding: '0 0 0', display: 'flex', gap: '10px', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <button onClick={handleContinueShopping} style={{ paddingInline: '18px', height: '38px', borderRadius: '6px', fontSize: '14px', fontWeight: 400, backgroundColor: 'white', border: '1px solid #ddd', color: '#555', cursor: 'pointer', transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: '8px' }} onMouseOver={(e) => { e.target.style.borderColor = '#111'; e.target.style.color = '#111'; }} onMouseOut={(e) => { e.target.style.borderColor = '#ddd'; e.target.style.color = '#555'; }}>
                        Continue Shopping
                    </button>
                    <button onClick={handleViewCart} style={{ paddingInline: '18px', height: '38px', borderRadius: '6px', fontSize: '14px', fontWeight: 400, backgroundColor: '#111', border: 'none', color: 'white', cursor: 'pointer', transition: 'all 0.2s' }} onMouseOver={(e) => e.target.style.backgroundColor = '#333'} onMouseOut={(e) => e.target.style.backgroundColor = '#111'}>View Cart</button>
                </div>
            </div>
        </Modal>
    );
};

export default CartModal;